import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import AppConfig from '../../config';
import Icon, { Icons } from '../Icon/Icon';
import Input from '../Input';
import CountryPrefix from './components/CountryPrefix/CountryPrefix';
import { countries } from './lib/countries';

import './PhoneInput.scss';

const { routes } = AppConfig;
const SESSION_COUNTRY_KEY = 'selected-country';

const PhoneInput = ({ value, onChange }) => {
	const navigate = useNavigate();
	const [country, setCountry] = useState(countries[0]);

	useEffect(() => {
		const stored = sessionStorage.getItem(SESSION_COUNTRY_KEY);
		if (stored) {
			try {
				onChange(JSON.parse(stored).code);
				sessionStorage.removeItem(SESSION_COUNTRY_KEY);
			} catch {}
		}
	}, []);

	useEffect(() => {
		if (!value) return;

		const matchedCountry = countries.find(c => value.startsWith(c.code));

		if (matchedCountry) {
			setCountry(matchedCountry);
		}
	}, [value]);

	const localPhone = useMemo(() => {
		if (!value) return '';
		return value.replace(country.code, '');
	}, [value, country.code]);

	const handleChange = e => {
		const nextLocal = e.target.value;
		onChange(nextLocal ? `${country.code}${nextLocal}` : '');
	};

	const goToCountryList = () => {
		navigate(routes.selectCountryCode);
	};

	const crossButton = (
		<Icon
			className='PhoneInput__cross-icon'
			onClick={() => onChange('')}
			type={Icons.XMARK_CIRCLE_FILL}
			width={20}
			height={20}
		/>
	);

	return (
		<Input
			type='number'
			inputMode='numeric'
			pattern='[0-9]*'
			value={localPhone}
			onChange={handleChange}
			prefix={<CountryPrefix country={country} onClick={goToCountryList} />}
			postfix={localPhone ? crossButton : null}
			className='FormBlock'
		/>
	);
};

export default PhoneInput;
